import React from 'react';

import { Skeleton } from '@material-ui/lab';

import Card from '../../../Card';
import Divider from '../../../Divider';

import { FaqListSkeletonProps } from './FaqListSkeleton.types';

const FaqListSkeleton: React.FC<FaqListSkeletonProps> = ({ className, size }) => {
  return (
    <Card className={`flex flex-column pt4 ${className}`}>
      {Array(size)
        .fill(0)
        .map((_el, ind) => (
          <>
            <div className="flex flex-justify">
              <Skeleton
                variant="rect"
                key={ind}
                width={150}
                height={16}
                className={`mx3 ${ind !== size - 1 ? 'mb3' : ''}`}
              />
              <Skeleton
                variant="circle"
                height={24}
                width={24}
                className="mr2 mb2"
              />
            </div>
            {ind !== size - 1 && <Divider className="mb3" />}
          </>
        ))}
    </Card>
  );
};

export default FaqListSkeleton;
export { FaqListSkeletonProps };
